import React, {useEffect, useState} from "react";
import {
    Avatar,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    IconButton,
    ListItem,
    Spacer,
    UnorderedList,
    useDisclosure,
    Tooltip,
} from '@chakra-ui/react'
import {ChevronRightIcon, HamburgerIcon} from '@chakra-ui/icons'
import {Link} from "react-router-dom";
import {AiOutlineLeft} from 'react-icons/ai';
import {replaceurlbystore, ShopifyStoreFrontAccessToken, ShopifyStoreLink} from "../../../GlobalVar";
import {useQuery} from "react-query";
import {shopifyAxios} from "../../apiClients/shopifyClient";
// import {useQuery} from "react-query";
// import {shopifyAxios} from "../../apiClients/shopifyClient";

export function MobileDrawer() {
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [show, setShow] = useState(false);
    const [show360, setShow360] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [showsubmenu, setshowsubmenu] = useState(false);
    const [showsubmenuchild, setshowsubmenuchild] = useState(false);
    const [Index, setIndex] = useState(0)
    const [Index2, setIndex2] = useState(0)
    const [menus, setMenus] = useState('')
    const coBrowsingInstance = window.coBrowsingInstance;

    useEffect(() => {
        getMenu();
    }, [])

    const AllFalse = () => {
        onClose();
        setShow(false);
        setshowsubmenu(false);
        setshowsubmenuchild(false);
        setShow360(false);
        setShowHelp(false);
    }

    const Menuhover = (index1, index2) => {
        if (index2) setIndex2(index2)
        setIndex(index1);
    }

    const getMenu = () => {
        const query = `{
      menu(handle: "shop-products") {
         items {
          title
          url
          items {
            title
            url
            items {
              title
              url
            }
          }
        }
      }
     }`;
        fetch(ShopifyStoreLink, {
            method: "POST", body: query, headers: {
                'Content-Type': 'application/graphql', 'X-Shopify-Storefront-Access-Token': ShopifyStoreFrontAccessToken
            }
        })
            .then(response => {
                const data = response.json()
                Promise.all([data]).then((values) => {
                    setMenus(values[0]['data']['menu']['items']);
                });

            })
    }

    const {data: drillClub360} = useQuery('drillclub-360', () => {
        const query = `{
        menu(handle: "drillclub-360") {
           items {
            title
            url
            items {
              title
              url
              items {
                title
                url
              }
            }
          }
        }
       }`;
        return shopifyAxios.post('', query);
    }, {
        refetchOnWindowFocus: false, select: res => {
            return res.data?.data?.menu?.items;
        }
    });

    const getLastPart = (url) => {
        const replacedUrl = url.replace(`${replaceurlbystore}`, '');
        return replacedUrl.split('/').pop();
    }

    return (<>
        <Flex
            ml={{base: 0, md: 60}}
            alignItems="center"
            justifyContent={{base: 'space-between', md: 'flex-end'}}>
            <Avatar
                as={IconButton}
                icon={<HamburgerIcon/>}
                variant='outline'
                className='icon menu_icon_mobile_view hamburger_menu_icon'
                onClick={onOpen}
                aria-label="open menu"
                cursor='pointer'
            />
        </Flex>
        <Drawer placement="left" onClose={onClose} isOpen={isOpen} isFullHeight='true'>
            <DrawerOverlay className="menu_drawer_overlay"/>
            <DrawerContent className='drawer_menu_mt' overflow='scroll'>
                <DrawerBody className="drawer_body_content_mt">
                    <UnorderedList className='mobile_menu_list'>
                        <ListItem className='list_button_menu_mobile'>
                            <DrawerCloseButton className="drawermenu_close_button_mt">
                                <p className="drawermenu_close_button_mt_text">Close</p>
                            </DrawerCloseButton>
                        </ListItem>
                        <ListItem className='list_items_menu_mobile'>
                            <button type='button' className="drawermenu_item_mt" onClick={() => setShow(true)}>
                                <span>Shop Products </span>
                                <span><ChevronRightIcon aria-label="Open Shop Products submenu"/></span>
                            </button>
                        </ListItem>
                        {show ? <>
                            <Drawer placement="right" isOpen={isOpen}>
                                <DrawerOverlay className="menu_drawer_overlay"/>
                                <DrawerContent className='drawer_menu_mt'>
                                    <DrawerBody className="drawer_body_content_mt">
                                        <ListItem className='list_button_menu_mobile'>
                                            <DrawerCloseButton justifyContent={"space-between !important"}
                                                               className="drawermenu_close_button_mt">
                                                <span className="drawermenu_close_button_mt_text"
                                                      onClick={() => setShow(false)}><AiOutlineLeft/>Back</span>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    AllFalse();
                                                }}>Close</span>
                                            </DrawerCloseButton>
                                        </ListItem>
                                        <Flex className='chiled_header' bg="white"> <span
                                            className="main_menu_showdrawer_mt">CATEGORIES</span> <Spacer/>
                                            <Link to='/collections'
                                                  onClick={() => AllFalse()}
                                                  style={{color: '#EC7700', cursor: "pointer"}}>View
                                                all</Link></Flex>
                                        {menus && menus.map((menu, i) => {
                                            return (<ListItem className='list_items_menu_mobile'>
                                                <button type='button'
                                                        className="drawermenu_item_mt" onClick={() => {
                                                    Menuhover(i);
                                                    setshowsubmenu(true)
                                                }}>
                                                    <span>{menu.title}</span><span><ChevronRightIcon aria-label={`Open ${menu.title} submenu`}/></span>
                                                </button>
                                            </ListItem>)
                                        })}
                                    </DrawerBody>
                                </DrawerContent>
                            </Drawer>
                            {showsubmenu ? <Drawer placement="right" isOpen={isOpen}>
                                <DrawerContent className='drawer_menu_mt'>
                                    <DrawerBody className="drawer_body_content_mt">
                                        <ListItem className='list_button_menu_mobile'>
                                            <DrawerCloseButton className="drawermenu_close_button_mt"
                                                               justifyContent={"space-between !important"}>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    setShow(true);
                                                    setshowsubmenu(false)
                                                }}><AiOutlineLeft/>Back</span>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    AllFalse();
                                                }}>Close</span>
                                            </DrawerCloseButton>
                                        </ListItem>
                                        <Flex className='chiled_header' bg="white"> <span
                                            className="main_menu_showdrawer_mt">{menus[Index].title}</span>
                                            <Spacer/> <Link
                                                to={`/collections/${getLastPart(menus[Index].url)}`}
                                                onClick={AllFalse}
                                                style={{color: '#EC7700', cursor: "pointer"}}>View
                                                all</Link></Flex>
                                        {menus[Index].items.map((child, index) => {
                                            let url = `/collections/${getLastPart(menus[Index].url)}/${getLastPart(child.url)}`;
                                            return (child.items.length === 0 ? <ListItem key={index} onClick={() => {
                                                    onClose();
                                                    AllFalse()
                                                }} className='list_items_menu_mobile'><Link
                                                    to={url}
                                                    className="drawermenu_item_mt">{child.title}</Link></ListItem> :
                                                <ListItem key={index}
                                                          className='list_items_menu_mobile'>
                                                    <button type='button'
                                                            className="drawermenu_item_mt"
                                                            onClick={() => {
                                                                Menuhover(Index, index);
                                                                setshowsubmenuchild(true);
                                                            }}>
                                                        <span>{child.title}</span><span><ChevronRightIcon aria-label={`Open ${child.title} submenu`}/></span>
                                                    </button>
                                                </ListItem>)
                                        })}

                                    </DrawerBody>
                                </DrawerContent>
                            </Drawer> : null}

                            {showsubmenuchild ? <Drawer placement="right" isOpen={isOpen}>
                                <DrawerContent className='drawer_menu_mt'>
                                    <DrawerBody className="drawer_body_content_mt">
                                        <ListItem className='list_button_menu_mobile'>
                                            <DrawerCloseButton className="drawermenu_close_button_mt" justifyContent={"space-between !important"}>
                                                <span onClick={() => {
                                                    setshowsubmenu(true);
                                                    setshowsubmenuchild(false)
                                                }} className="drawermenu_close_button_mt_text"><AiOutlineLeft/>Back</span>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    AllFalse();
                                                }}>Close</span>
                                            </DrawerCloseButton>
                                        </ListItem>
                                        <Flex className='chiled_header' bg="white"> <span
                                            className="main_menu_showdrawer_mt">{menus[Index].items[Index2].title}</span>
                                            <Spacer/> <Link
                                                to={`/collections/${getLastPart(menus[Index].url)}/${getLastPart(menus[Index].items[Index2].url)}`}
                                                onClick={AllFalse}
                                                style={{
                                                    color: '#EC7700', cursor: "pointer"
                                                }}>View all</Link></Flex>
                                        {menus[Index].items[Index2].items.map((subChild, index) => {
                                            let url = `/collections/${getLastPart(menus[Index].url)}/${getLastPart(menus[Index].items[Index2].url)}/${getLastPart(subChild.url)}`;
                                            return (<ListItem key={index} onClick={() => {
                                                onClose();
                                                AllFalse()
                                            }} className='list_items_menu_mobile'><Link
                                                to={url}
                                                className="drawermenu_item_mt">{subChild.title}</Link></ListItem>)
                                        })}
                                    </DrawerBody>
                                </DrawerContent>
                            </Drawer> : null

                            }
                        </> : null}

                        <ListItem onClick={() => {
                            onClose();
                            AllFalse()
                        }} className='list_items_menu_mobile'>
                            <Link to='/our-brands' className="drawermenu_item_mt">Shop Brands</Link>
                        </ListItem>

                        <ListItem className='list_items_menu_mobile'>
                            <button type='button' className="drawermenu_item_mt"  onClick={() => setShow360(true)}>
                                <span>DRILLCUT 360 </span>
                                <span><ChevronRightIcon aria-label="Open DRILLCUT 360 submenu"/></span>
                            </button>
                        </ListItem>
                        {show360 && <>
                            <Drawer placement="right" isOpen={isOpen}>
                                <DrawerOverlay className="menu_drawer_overlay"/>
                                <DrawerContent className='drawer_menu_mt'>
                                    <DrawerBody className="drawer_body_content_mt">
                                        <ListItem className='list_button_menu_mobile'>
                                            <DrawerCloseButton
                                                               justifyContent={"space-between !important"}
                                                               className="drawermenu_close_button_mt">
                                                <span className="drawermenu_close_button_mt_text" onClick={() => setShow360(false)}>
                                                    <AiOutlineLeft/>Back
                                                </span>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    AllFalse();
                                                }}>Close</span>
                                            </DrawerCloseButton>
                                        </ListItem>

                                        <ListItem onClick={() => {
                                            onClose();
                                            AllFalse()
                                        }} className='list_items_menu_mobile'>
                                            <Link className="drawermenu_item_mt" to="/pages/360">
                                                DrillCut 360
                                            </Link>
                                        </ListItem>

                                        {drillClub360?.map((drillClub) => {
                                            const replacedUrl = drillClub?.url?.replace(replaceurlbystore, '');
                                            if (replacedUrl.startsWith('/')) {
                                                return (<ListItem onClick={() => {
                                                    onClose();
                                                    AllFalse()
                                                }} className='list_items_menu_mobile'>
                                                    <Link className="drawermenu_item_mt" to={replacedUrl}>
                                                        {drillClub?.title}
                                                    </Link>
                                                </ListItem>)
                                            } else {
                                                return (<ListItem onClick={() => {
                                                    onClose();
                                                    AllFalse()
                                                }} className='list_items_menu_mobile'>
                                                    <Tooltip label="opens in new tab" fontSize="md" placement='top'>
                                                        <a className="drawermenu_item_mt" href={replacedUrl} target="_blank"
                                                           rel="noreferrer" aria-label={`${drillClub?.title} (opens in new tab)`}>
                                                            {drillClub?.title}
                                                        </a>
                                                    </Tooltip>
                                                </ListItem>)
                                            }
                                        })}

                                    </DrawerBody>
                                </DrawerContent>
                            </Drawer>
                        </>}

                        {/*<ListItem onClick={() => {*/}
                        {/*    onClose();*/}
                        {/*    AllFalse()*/}
                        {/*}} className='list_items_menu_mobile'>*/}
                        {/*    <Link to='/drillclub' className="drawermenu_item_mt">Drillclub</Link>*/}
                        {/*</ListItem>*/}

                        <ListItem onClick={() => {
                            onClose();
                            AllFalse()
                        }} className='list_items_menu_mobile'>
                            <Link to='/downloads' className="drawermenu_item_mt">Downloads</Link>
                        </ListItem>

                        <ListItem onClick={() => {
                            onClose();
                            AllFalse()
                        }} className='list_items_menu_mobile'>
                            <Link to='/drillcut-tv' className="drawermenu_item_mt">Drillcut TV</Link>
                        </ListItem>

                        <ListItem onClick={() => {
                            onClose();
                            AllFalse()
                        }} className='list_items_menu_mobile'>
                            <Link to='/news-and-learning' className="drawermenu_item_mt">News And learning</Link>
                        </ListItem>

                        <ListItem className='list_items_menu_mobile'>
                            <button type='button' className="drawermenu_item_mt" onClick={() => setShowHelp(true)}>
                                <span>Help </span>
                                <span><ChevronRightIcon aria-label="Open Help submenu"/></span>
                            </button>
                        </ListItem>
                        {showHelp && <>
                            <Drawer placement="right" isOpen={isOpen}>
                                <DrawerOverlay className="menu_drawer_overlay"/>
                                <DrawerContent className='drawer_menu_mt'>
                                    <DrawerBody className="drawer_body_content_mt">
                                        <ListItem className='list_button_menu_mobile'>
                                            <DrawerCloseButton justifyContent={"space-between !important"}
                                                               className="drawermenu_close_button_mt">
                                                <span className="drawermenu_close_button_mt_text" onClick={() => setShowHelp(false)}>
                                                    <AiOutlineLeft/>Back
                                                </span>
                                                <span className="drawermenu_close_button_mt_text" onClick={() => {
                                                    AllFalse();
                                                }}>Close</span>
                                            </DrawerCloseButton>
                                        </ListItem>

                                        <ListItem onClick={() => {
                                            onClose();
                                            AllFalse()
                                        }} className='list_items_menu_mobile'>
                                            <Tooltip label="opens in new tab" fontSize="md" placement='top'>
                                                <a href="https://support.drillcut.au/" className="drawermenu_item_mt"
                                                   target="_blank" rel="noreferrer" aria-label="Help Centre (opens in new tab)">Help Centre</a>
                                            </Tooltip>
                                        </ListItem>
                                        {coBrowsingInstance && <ListItem onClick={() => {
                                            onClose();
                                            AllFalse()
                                        }} className='list_items_menu_mobile'>
                                            <button type='button'
                                                    className="drawermenu_item_mt"
                                                    onClick={() => coBrowsingInstance.showPopup()}>
                                                Co Browse
                                            </button>
                                        </ListItem>}

                                    </DrawerBody>
                                </DrawerContent>
                            </Drawer>
                        </>}

                    </UnorderedList>
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    </>)
}
